export default __webpack_public_path__ + "static/media/title-graphic.7be81a4a.png";